import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'AnaliseTecItem'

const Create = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIPci}/${resourceName}`, data, config)
const Delete = (id, data = {}, config = {}) => APIClient.delete(`${APIPci}/${resourceName}/${id}`, data, config)

export default {
  Create,
  Update,
  Delete
}



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/tecanalysisitem.js